var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"header-bg-variant":_vm.dialogVariant,"button-size":"sm","ok-only":"","title":_vm.dialogTitle,"ok-variant":_vm.buttonVariant},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v(" "+_vm._s(_vm.dialogMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }